import { arrayMove } from '@dnd-kit/sortable';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	IconButton,
	Stack,
} from '@mui/material';
import { closeSnackbar, useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DndArticleListSection from './info-order/DndArticleListSection';
import CloseIcon from '@mui/icons-material/Close';
import FormatLineSpacingIcon from '@mui/icons-material/FormatLineSpacing';
import { useGetPuzzleSortListQuery } from '@/api/treasury/puzzleApiSlice';
import { useSortPuzzleMutation } from '@/api/treasury/puzzleApiSlice';

interface Props {}

export default function SetPuzzleOrderDialog(props: Props) {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const [open, setOpen] = useState(false);
	const [sortPuzzle] = useSortPuzzleMutation();

	const [meditationItems, setMeditationItems] = useState<any>([]);

	const { data: propertySummary, isSuccess: isGetPropertySummarySuccess } =
		useGetPuzzleSortListQuery(null, {
			refetchOnMountOrArgChange: true,
			skip: !open,
		});

	useEffect(() => {
		const list = Array.isArray(propertySummary?.data)
			? propertySummary?.data
			: [];
		setMeditationItems(list);
	}, [isGetPropertySummarySuccess, propertySummary]);

	const handleRepositionItem = (activeIndex: number, overIndex: number) => {
		setMeditationItems((prev: unknown[]) =>
			arrayMove(prev, activeIndex, overIndex)
		);
	};

	const onSubmit = async () => {
		const arr = meditationItems.map((item: { id: string }) => item.id);
		const response = await sortPuzzle(arr);
		if ('data' in response) {
			enqueueSnackbar(t('snackbar.sortSuccess'), {
				variant: 'success',
				anchorOrigin: { horizontal: 'center', vertical: 'top' },
				autoHideDuration: 3000,
				action: (key) => {
					return <CloseIcon onClick={() => closeSnackbar(key)} />;
				},
			});
			handleClose();
		}
	};

	const handleClose = () => {
		setOpen(false);
	};

	const formContent = (
		<>
			<Button
				variant='contained'
				style={{ alignItems: 'center' }}
				endIcon={<FormatLineSpacingIcon />}
				onClick={() => setOpen(true)}
			>
				{t('meditation.rearrangement')}
			</Button>
			<Dialog
				open={open}
				onClose={() => handleClose()}
				aria-labelledby='alert-dialog-title'
				aria-describedby='alert-dialog-description'
				maxWidth='lg'
				fullWidth
			>
				<DialogTitle variant='h5'>{t('meditation.rearrangement')}</DialogTitle>
				<IconButton
					aria-label='close'
					onClick={() => handleClose()}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<CloseIcon />
				</IconButton>
				<DialogContent>
					<Grid container alignItems='stretch' columnSpacing={3} marginTop={3}>
						<Grid item xs display='flex'>
							<Stack>
								{meditationItems && (
									<DndArticleListSection
										meditationItems={meditationItems}
										handleRepositionItem={handleRepositionItem}
									/>
								)}
							</Stack>
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => handleClose()}>{t('button.cancel')}</Button>

					<Button type='submit' variant='contained' onClick={() => onSubmit()}>
						{t('button.save')}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
	return <>{formContent}</>;
}
